import { AllowedErc20Limit as O } from "../constants/contract.js";
import w from "./useContract.js";
import "../../currency-lib/constants/currency.js";
import { useCurrencyContext as g } from "../../currency-lib/contexts/CurrencyContext.js";
import "../../currency-lib/deserialize/yup/currency.js";
import "@apollo/client";
import "../../currency-lib/graphql/query/getCurrencyInfo.js";
import * as y from "ramda";
import { useCallback as m } from "react";
import "../../config-lib/contexts/FrontendConfigContext.js";
import "../../currency-lib/graphql/query/getOffChainTokenBalances.js";
import "../../currency-lib/hooks/graphql/useGetTokenPriceToUSD.js";
import { ChainAddressType as o } from "../../temp-lib/constants/chain.js";
import A from "../../temp-lib/hooks/web3/useWeb3.js";
import { erc20Abi as N } from "viem";
const E = () => {
  const {
    getCurrency: s
  } = g(), {
    callWithOption: u,
    sendWithOption: d
  } = w(), {
    toWei: l
  } = A(), c = m((r, t, i) => ({
    abi: {
      [o.POLYGON]: N,
      [o.RONIN]: N
    },
    address: {
      [o.POLYGON]: r,
      [o.RONIN]: r
    },
    method: i,
    spenderAddress: {
      [o.POLYGON]: t,
      [o.RONIN]: t
    }
  }), []), f = m(async (r) => {
    const {
      currencyType: t,
      price: i,
      spenderAddress: n,
      userAddress: p
    } = r, e = s(t);
    if (y.isNil(e) || i <= 0)
      return BigInt(-1);
    const a = await u({
      contract: c(e.address, n, "allowance")
    }, p, n);
    return BigInt(a);
  }, [u, s, c]);
  return {
    request: m(async (r) => {
      const {
        currencyType: t,
        price: i,
        spenderAddress: n
      } = r, p = await f(r);
      if (p <= i) {
        const e = s(t);
        if (y.isNil(e))
          return !1;
        const a = BigInt(l(O, e.decimals)) - p;
        await d({
          contract: c(e.address, n, "approve")
        }, n, a);
      }
      return !0;
    }, [f, s, l, d, c])
  };
};
export {
  E as default
};
//# sourceMappingURL=useApproveErc20.js.map
